import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../ui/button/button';
import Icon from '../../../common/icon/icon';
import RemoveSchoolSuggestionModal from '../../../common/remove-school-suggestion-modal/remove-school-suggestion-modal';
import { BUTTON_VARIANTS } from '../../../constants/button-variants';
import translation from '../../../languages';
import schoolAccount from '../../../utils/school-account';

type SchoolWishlistRemoveButtonProps = TranslationProps & {
    item: Material;
    type?: 'button' | 'icon' | 'removeOnly';
    onSubmit?: () => void;
};

const SchoolWishlistRemoveButton: FC<SchoolWishlistRemoveButtonProps> = ({ t, ...props }) => {
    const { item, onSubmit } = props;
    const [isRemoveModalOpen, setIsRemoveModalOpen] = useState<boolean>(false);

    const user = useSelector((state: RootState) => state.main.user);
    const currentUserId = useSelector(
        (state: RootState) => state.main.user.profileDetails.details.schoolAccount?.staff_id
    );

    const isAdmin = schoolAccount.isAdmin(user);
    const isSelf = item.schoolWishlistSuggestedBy?.id === currentUserId;

    if (!isAdmin && !isSelf) {
        return null;
    }

    const removeLabel = t('common.schoolWishlist.removeSuggestionButton');
    const shouldRenderButton = props.type === 'removeOnly';

    const handleCloseModal = () => setIsRemoveModalOpen(false);
    const handleButtonClick = (): void => setIsRemoveModalOpen(true);
    const handleRemoved = () => onSubmit?.();

    return (
        <>
            <span className={shouldRenderButton && isAdmin ? 'school-wishlist-admin-remove' : undefined}>
                {!shouldRenderButton && <Icon name='delete' onClick={handleButtonClick} />}

                {shouldRenderButton && (
                    <Button variant={BUTTON_VARIANTS.SECONDARY} onClick={handleButtonClick}>
                        {removeLabel}
                    </Button>
                )}
            </span>

            <RemoveSchoolSuggestionModal
                isOpen={isRemoveModalOpen}
                materialId={item.id}
                onClose={handleCloseModal}
                onRemoved={handleRemoved}
            />
        </>
    );
};

const translate = translation('common');

export default translate(SchoolWishlistRemoveButton);
